import {connect} from "react-redux";
import UCDCases from "./Case";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {
    ucdById,
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    addCaseRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest
} from "../../../../../service/Dealer/action";
import { fetchCustomerDetails } from "../../../../../service/LeadManagement/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    ucdDetails: state.Dealer.ucdDetails,
    ucsUpdateResponse: state.Dealer.ucdUpdate,
    addCaseResponse: state.Dealer.addCaseResponse,
    carBrandResponse: state.Dealer.carBrandResponse,
    carModelResponse: state.Dealer.carModelResponse,
    carVariantResponse: state.Dealer.carVariantResponse,
    bankListResponse: state.Dealer.bankListResponse,
    newBankDetailsResponse: state.Dealer.newBankDetailsResponse,
    vehicleDetailsResponse: state.Dealer.vehicleDetailsResponse,
    getCustomerDetailsUsingPan: state.LeadManagement.getCustomerDetailsUsingPan
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            ucdById,
            carBrandRequest,
            carModelRequest,
            carVariantRequest,
            bankListRequest,
            addCaseRequest,
            newBankDetailsRequest,
            vehicleDetailsRequest,
            fetchCustomerDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDCases);
